import { ListDataType } from '@shared/components/list-view-v2';

export const dataFormatterListDataTypeToPercent = (number: ListDataType) =>
  !number ? `${Number(0).toFixed(1)}%` : `${number}%`;
